import React,{useState, useEffect} from "react";
import checkIcon from "../assets/checkIcon.png"
import UploadCV from "../components/Upload/UploadCV";
import UploadMotivationLetter from "../components/Upload/UploadMotivationLetter"
import LinkedInProfile from '../components/Upload/LinkedInProfile'
import { gsap } from 'gsap';

function Upload({setCVFile, setMLetterFile, setLinkedInURL, cvFile, mLetterfile, linkedInURL, linkedInData, setLinkedInData,
  uploadProgress, setUploadProgress, uploadComplete, setUploadComplete, uploading, setUploading, isDragging, setIsDragging,
  uploadMLetterProgress, setUploadMLetterProgress, uploadMLetterComplete, setUploadMLetterComplete, uploadMLetterUploading, setUploadMLetterUploading, uploadMLetterIsDragging, setUploadMLetterIsDragging
}) {

  const [activeIndicator, setActiveIndicator] = useState(1);

  const [indicators] = useState([
    {
      id: 1,
      title: "Upload CV",
    },
    {
      id: 2,
      title: "Upload Motivational Letter"
    },
    {
      id: 3,
      title: "LinkedIn Profile"
    }
  ])

  const isStepCompleted = (id) => {
    switch (id) {
      case 1:
        return cvFile !== null;
      case 2:
        return mLetterfile !== null;
      case 3:
        return linkedInURL !== '';
      default:
        return false;
    }
  };

  const uploadComponents = [ 
  <UploadCV
      setActiveIndicator={setActiveIndicator}
        cvFile={cvFile}
        setCVFile={setCVFile}
        uploadProgress={uploadProgress}
        setUploadProgress={setUploadProgress}
        uploadComplete={uploadComplete}
        setUploadComplete={setUploadComplete}
        uploading={uploading}
        setUploading={setUploading}
        isDragging={isDragging}
        setIsDragging={setIsDragging}
      />,
      <UploadMotivationLetter
      setActiveIndicator={setActiveIndicator}
      mLetterfile={mLetterfile}
      setMLetterFile={setMLetterFile}
      uploadProgress={uploadMLetterProgress}
      setUploadProgress={setUploadMLetterProgress}
      uploadComplete={uploadMLetterComplete}
      setUploadComplete={setUploadMLetterComplete}
      uploading={uploadMLetterUploading}
      setUploading={setUploadMLetterUploading}
      isDragging={uploadMLetterIsDragging}
      setIsDragging={setUploadMLetterIsDragging}
      />, <LinkedInProfile
      setActiveIndicator={setActiveIndicator}
      linkedInURL={linkedInURL}
      setLinkedInURL={setLinkedInURL}
      cvFile={cvFile}
      mLetterfile={mLetterfile}
      linkedInData={linkedInData}
      setLinkedInData={setLinkedInData}
      />]

  const setGSAPProperties = (element, props) => {
    if (props.force3D) {
      element.style.transform = 'translate3d(0, 0, 0)';
    }
    if (props.willChange) {
      element.style.willChange = props.willChange;
    }
  };

  const resetGSAPProperties = (element) => {
    element.style.willChange = 'auto';
  };

  // Direct fadeUp animation
  const initFadeUp = () => {
    const fadeUpElements = document.querySelectorAll(".fadeUp");

    if (fadeUpElements.length === 0) {
      setTimeout(initFadeUp, 100);
      return;
    }

    // Set CSS properties directly for better performance
    fadeUpElements.forEach(element => {
      setGSAPProperties(element, { force3D: true, willChange: "transform, opacity" });
    });

    const animationDelay = 0; // Base delay in milliseconds

    gsap.set(fadeUpElements, { 
      opacity: 0, 
      y: 20
    });
    
    gsap.to(fadeUpElements, {
      opacity: 1,
      y: 0,
      duration: 0.6,
      delay: 0.2 + (animationDelay / 1000), // Add navbar delay to base delay
      stagger: 0.1,
      ease: "power2.out",
      onComplete: () => {
        // Reset CSS properties after animation
        fadeUpElements.forEach(element => {
          resetGSAPProperties(element);
        });
      }
    });
  };

  useEffect(() => {
    initFadeUp();
  }, []);  

  
  return (
    <div>
      <div className="mt-8 flex gap-4 justify-center">
        {indicators.map((indicator) =>{
          const isCompleted = isStepCompleted(indicator.id);
          return(
           <div className="fadeUp">
           <div key={indicator.id} className={`flex gap-2 items-center ${indicator.id === activeIndicator ? "opacity-100" : "opacity-50"}`}
            onClick={() => setActiveIndicator(indicator.id)}>
              <span className={`w-14 h-14 rounded-full flex items-center justify-center ${indicator.id === activeIndicator ? "bg-primary" : "bg-default"}`}>
                {isCompleted ? (
                  <img src={checkIcon} className="w-8 h-8" alt="completed" />
                ) : (
                  <p className="font-bold text-white">
                    {indicator.id}
                  </p>
                )}
              </span>
              <span>{indicator.title}</span>
            </div>
           </div>
          )
        })}
      </div>
      <div className="mt-16 fadeUp">
     {uploadComponents[activeIndicator -1]}
      </div>
    </div>
  );
}

export default Upload; 